import { productApiOrigin } from "../config/apiOrigin";
import { createOperationalTelemetry } from "./operationalTelemetry";

type Input = Parameters<ReturnType<typeof createOperationalTelemetry>["record"]>[0];
const artifactSha = import.meta.env.VITE_ARTIFACT_SHA ?? "";
const apiOrigin = productApiOrigin || (typeof window !== "undefined" ? window.location.origin : "");
const telemetry = /^[0-9a-f]{64}$/.test(artifactSha) && apiOrigin
  ? createOperationalTelemetry({ artifactSha, apiOrigin }) : null;

function safeSegment(segment: string) {
  return /^[A-Za-z_-]{1,32}$/.test(segment) ? segment : ":id";
}

export function operationalRouteTemplate(pathname: string) {
  if (!pathname.startsWith("/") || pathname.startsWith("//")) return "/*";
  // The leading "/" makes this template literal always non-empty, so the
  // `|| "/"` fallback could never fire — dead code, removed.
  return `/${pathname.split("/").filter(Boolean).map(safeSegment).join("/")}`;
}

export function operationalApiRouteFamily(candidate: unknown): string | null {
  if (typeof candidate !== "string") return null;
  try {
    const path = new URL(candidate, "https://product.invalid").pathname;
    if (!path.startsWith("/api/")) return null;
    return operationalRouteTemplate(path).slice(0, 160);
  } catch {
    return null;
  }
}

export async function recordOperationalEvent(input: Input) {
  try { await telemetry?.record(input); } catch { /* telemetry must never break recovery */ }
}

export async function flushOperationalEvents() {
  try { await telemetry?.flush(); } catch { /* retry on a later recovery seam */ }
}
